import * as Yup from 'yup';

// Helper function to check if a string is an email
const isEmail = (value) => {
    if (!value) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
};

// Helper function to check if a string is a phone number
const isPhoneNumber = (value) => {
    if (!value) return false;
    const phoneRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/;
    return phoneRegex.test(value);
};

// Validation schema for user authentication
export const AuthenticationSchema = Yup.object({
    emailOrPhone: Yup.string()
        .required("Please provide your email or phone number")
        .test('email-or-phone-format', 'Please enter a valid email address or phone number', function(value) {
            if (!value || value.trim().length === 0) {
                return false;
            }
            return isEmail(value) || isPhoneNumber(value);
        }),
    password: Yup.string().required("Please provide your password"),
});

export const RegistrationSchema = Yup.object({
    name: Yup.string().required('Your name is required'),
    email: Yup.string().email('Invalid email address').required('Please provide your email address'),
    password: Yup.string().required('Please provide your password'),
    confirmPassword: Yup.string()
      .required('Please confirm your password') 
      .oneOf([Yup.ref('password'), null], 'Passwords must match'), 
  });

export const ForgotPasswordSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Email is required")
});

export const TokenSchema = Yup.object({
    token: Yup.string().required("Token is required").default(""),
    refreshToken: Yup.string().required("Refresh token is required").default("")
});

export const CodeSchema = Yup.object({
    code: Yup.string().required("code is required").default(""),
    
});
